import { api } from '@/integrations/clients/carAuction/carAuctionClient';
import { GetAllMakesResponse } from '@/types/make';

export class MakesService {
  private static baseUrl = '/makes';

  // Get all makes with models and engines
  static async getAllMakes(): Promise<GetAllMakesResponse> {
    const response = await api.get<GetAllMakesResponse>(this.baseUrl);
    return response;
  }
}


